{
  "$schema": "http://json-schema.org/draft-07/schema#",
  "$id": "chatgpt",
  "title": "ChatGPT",
  "description": "ChatGPT agent settings: how a conversation started in ChatGPT continues on your website.",
  "type": "object",
  "properties": {
    "resume_landing_url": {
      "ui:sectionTitle": "ChatGPT",
      "ui:sectionDescription": "Where visitors resume after ChatGPT.",
      "ui:sectionIcon": "MessageSquare",
      "type": [
        "string",
        "null"
      ],
      "format": "uri",
      "ui:tooltip": "The page a ChatGPT conversation reopens on when the visitor clicks through to your website.",
      "ui:description": "Set this only if your homepage redirects visitors to another page (e.g. a language path like /fr/) and that redirect drops URL parameters — which stops the ChatGPT conversation from reopening. Enter the exact page where Rose loads and keeps the link, for example https://payfit.com/fr/. Leave empty to use your homepage."
    }
  },
  "default": {
    "resume_landing_url": null
  }
}
